import { infiniteHits } from "instantsearch.js/es/widgets";
import { catalogHitTpl } from "./tpl-catalogHit";

export const catalogHits = infiniteHits({
    container: "[data-widget='catalogHits']",
    escapeHTML: true,
    cssClasses: {
        list: "lg:-mx-6",
    },
    templates: {
        item: catalogHitTpl,
    },
});
